import React, { Component, Fragment } from 'react';
import { FormOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import PowerSelectPanel from './powerSelectPanel';


class TargetICContent extends Component {

  ICSelect = (value) => {
    const { designId } = this.props
    setTimeout(() => {
      this.props._changeTargetIC(value, designId)
    }, 50)
  }

  closePanel = () => {
    this.changePanelStatus(false);
  }

  changePanelStatus = (bool, e, isLoadingNets) => {
    e && e.preventDefault() && e.stopPropagation();
    const { updateOpenTargetICLoading, updateSelectPowerNets } = this.props;
    bool && updateOpenTargetICLoading && updateOpenTargetICLoading(true);
    updateSelectPowerNets({ open: bool, isLoadingNets });
  }

  render() {
    const { loadComponents, loadSelect, powerNetSelect, loading, openTargetICLoading } = this.props;
    const { open = false, select = [], allPowerNets = [], allNets = [] } = powerNetSelect;
    const value = loadSelect.length ? loadSelect[0].comp : '';
    return (
      <Fragment>
        <span className="font-bold cascade-setup-title-color-only">Target IC</span>
        <Select
          value={value}
          style={{ width: 240, marginLeft: 20 }}
          onChange={this.ICSelect}
          getPopupContainer={((trigger) => trigger.parentNode || document.getElementById('root'))}
          styles={{ popup: { root: { zIndex: 200 } } }}
          showSearch={true}
          options={loadComponents.map(option => ({
            value: option.name,
            label: option.name
          }))}
        />
        {value && <FormOutlined
          className="cascade-refresh-icon"
          style={open || loading ? { color: "rgba(0,0,0,0.65)", cursor: "not-allowed" } : {}}
          title="Select Power Nets"
          onClick={(e) => open || loading ? null : this.changePanelStatus(true, e, true)} />}
        {open ? <PowerSelectPanel
          closePanel={this.closePanel}
          select={select}
          openLoading={openTargetICLoading || false}
          allPowerNets={allPowerNets}
          refresh={this.props.refresh}
          comp={value}
          allNets={allNets}
        /> : null}
      </Fragment>
    );
  }
}

export default TargetICContent;